module.exports = __webpack_public_path__ + "static/media/Down.d3b880a2.svg";